/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Button } from '../../navigation/Button';
import { DarkBackgroundButton } from '../../navigation/DarkBackgroundButton';
import { IconButton } from '../../navigation/IconButton';
import { DarkBackgroundIconButton } from '../../navigation/DarkBackgroundIconButton';

type Props = {
  /**
   * Screenreader text. Be sure to pass this prop if `children` is empty!
   */
  ariaLabel?: string;
  /**
   * The text to render next to the back button.
   */
  children?: string;
  /**
   * Where the back button should link to.
   */
  href?: string;
  /**
   * If the button appears on a dark background -- V5 only
   * */
  isOnDarkBackground?: boolean;
  /**
   * Optional click handler.
   */
  onClick?: React.MouseEventHandler;
  /**
   * Optional text to render in a `Tooltip` for when the button renders
   * only as an icon.
   */
  tooltipText?: string;
};

export const BackButton = (props: Props) => {
  const sharedProps = {
    ariaLabel: props.ariaLabel,
    href: props.href,
    onClick: props.onClick,
    size: 'small' as 'small',
  };
  const ButtonComponent = props.isOnDarkBackground
    ? DarkBackgroundButton
    : Button;

  if (props.children) {
    return (
      <ButtonComponent
        {...sharedProps}
        color="secondary"
        iconBefore="arrowBigLeft"
      >
        {props.children}
      </ButtonComponent>
    );
  } else {
    if (props.isOnDarkBackground) {
      return (
        <DarkBackgroundIconButton
          {...sharedProps}
          color="icon-secondary"
          icon="arrowBigLeft"
          label={props.tooltipText}
          tooltipPosition="east"
        />
      );
    } else {
      return (
        <IconButton
          {...sharedProps}
          color="icon-alt"
          icon="arrowBigLeft"
          label={props.tooltipText}
          tooltipPosition="east"
        />
      );
    }
  }
};
